import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.413 16s1.016 2.356.375 3.517c-.68 1.2-2.402-.078-1.562-1.2.641-.89 1.522-1.354 1.522-1.354M12.426 14s1 2.201.36 3.471c-.68 1.313-2.4-.084-1.56-1.312.64-.974 1.52-1.228 1.52-1.228"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M6.08 15.464C4.257 15.344 3 14.477 3 12.712c0-1.619 1.63-3.183 3.302-3.25m0 0A2.58 2.58 0 0 1 8 10c2.034 1.555-.274 3.64-1.5 1.725-.374-.585-.423-1.4-.198-2.263m0 0c.513-1.963 2.44-4.167 5.163-4.437 3.918-.39 5.563 3.948 5.563 3.948s3.2-.27 3.44 2.752c.33 4.277-3.287 3.679-4.968 3.739"
    />
  </svg>
);
export const SadIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
